import { adobeTargetView } from "@/helpers/adobeTargetView";
import { useRouter } from 'next/compat/router'
import { useEffect } from "react";

export function usePageLoadActions() {
  const pathname = useRouter().asPath.split(/[?#]/)[0];

  //will run after the first render
  useEffect(() => {
    // Google custom pageview event
		dataLayer.push({ event: 'nsPageView' });
	}, []);

  //will run after first render and every subsequent rerender
  useEffect(() => {
    // Establish an Adobe Target view.  
    // This must be run on each rerender or else the rerender might override AT updates.
    adobeTargetView(pathname);
	});
  
}
